export default __webpack_public_path__ + "static/snowflake-21a625d64c66919956904fdefa622497.png";